import React from 'react'
import Changelog from './Changelog'

const ChangeLogView = () => (
  <div
    className='col-12 px-2 px-md-5 px-lg-7 h-100'
    style={{ overflowY: 'auto', overflowX: 'hidden' }}
  >
    <Changelog />
  </div>
)

export default ChangeLogView
